import httpRequest from "utils/httpRequest";
const URL = "/api";

export const getControlHistory = async (
  e_line,
  cur_page,
  fr_date,
  to_date,
  group_id,
  bsd_id,
) => {
  const requestBody = {
    e_line,
    cur_page,
    fr_date,
    to_date,
    group_id,
    bsd_id,
  };
  try {
    const response = await httpRequest(
      "post",
      `${URL}/ctrlHistory`,
      requestBody
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};
